import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Tooltip, IconButton, CircularProgress, Checkbox } from "@mui/material";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useContext, useState } from "react";
import { AcceptanceDataRow } from "./FindAcceptances";
import { useFindAcceptances } from "./useFindAcceptances";
import VillageConsoleContext from "../../store/VillageConsoleContext";
import { Domains } from "../../data/Domains";


type DisplayAcceptancesProps = {

    rows: AcceptanceDataRow[ ];

};


export const DisplayAcceptances: React.FC< DisplayAcceptancesProps > = ( props: DisplayAcceptancesProps ) => {

    const { rows } = props;

    const [loadingKey, setLoadingKey] = useState<number | null>( null );

    const { domain } = useContext( VillageConsoleContext );

    const { getAcceptancePdf } = useFindAcceptances( );


    const downloadPdf = ( pdf: string, row: AcceptanceDataRow ) => {
            
            const linkSource = `data:application/pdf;base64,${pdf}`;
            const downloadLink = document.createElement( 'a' );
            const fileName = `AcceptanceAgreement-${row.fullName}-${row.ruleVersion}.pdf`;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click( );
            setLoadingKey( null );

        }


    const handleDownloadPdfClick = async ( row: AcceptanceDataRow ) => {

        setLoadingKey( row.acceptanceId );
        
        const errorMessage = `Cannot find acceptance agreement: ${row.fullName}-${row.ruleVersion}`;

        const acceptancePdf = await getAcceptancePdf( row.acceptanceId, domain as Domains, errorMessage );

        if( acceptancePdf ) {
            
            downloadPdf( acceptancePdf, row );
            return;

        }

        setLoadingKey( null );

    };

    return(

        <TableContainer component={ Paper } sx={ { alignSelf: 'center', boxShadow: 5, width: '815px', overflowY: 'hidden' } } >
            
            <Table>
                
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ fontWeight: 'bold' }}>Full Name</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>Employee Number</TableCell>
                        { domain === Domains.Bma && <TableCell align="center" sx={{ fontWeight: 'bold' }}>Is Third Party</TableCell>  }
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>Department</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>Rule Version</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>Accepted</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>Actions</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    { rows.map( ( row ) => (
                        <TableRow key={ row.acceptanceId} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} hover>
                            <TableCell align="left">{ row.fullName }</TableCell>
                            <TableCell align="center">{ row.employeeNumber }</TableCell>
                            { domain === Domains.Bma && <TableCell align="center"> <Checkbox disabled checked={ row.isThirdParty } /> </TableCell> }
                            <TableCell align="center">{ row.department }</TableCell>
                            <TableCell align="center">{ row.ruleVersion }</TableCell>
                            <TableCell align="center">{ row.acceptedDateTime }</TableCell>
                            
                            <TableCell align="center">

                                <Tooltip title={ `Download PDF for ${row.ruleVersion}` }>
                                    <IconButton aria-label="download pdf" onClick={() => handleDownloadPdfClick(row)} disabled={Boolean(loadingKey)} >
                                        <PictureAsPdfIcon/>
                                        
                                        { ( loadingKey === row.acceptanceId ) && 
                                            <CircularProgress
                                                size={ 55 }
                                                sx={{
                                                    position: 'absolute',
                                                    top: 3,
                                                    left: 3,
                                                    zIndex: 1,
                                                    marginTop: '-10px',
                                                    marginLeft: '-10px',
                                                }}/>
                                        }
                                    </IconButton>
                                </Tooltip>

                            </TableCell>

                        </TableRow>
                    ))}
                </TableBody>

            </Table>

        </TableContainer>


    );


};